export enum PartyType {
    Consignee = 'consignee',
    Notify = 'notify',
    Dealer = 'dealer',
}

export type PartyData = {
    type: PartyType,
    country: string,
    city: string,
    address: string,
    phone: string,
    email: string,
    companyName: string,
    companyCode: string,
    firstName: string,
    middleName: string,
    lastName: string,
    tin: string,
    alias: string,
}

export type PartyModel = {
    id: number,
    carsCount: number,
    name: string,
    shortName: string,
    manager?: number,
} & PartyData;
